import React from 'react'
import Image from 'next/legacy/image'
import styled from 'styled-components'
import { ChipWrapper } from 'components/common/chip'
import { Column, Row } from 'components/common/layout'
import { Logo } from 'components/common/logo'
import { Tag, TagSize, TagType } from 'components/common/tag'
import { BoldText, DescText, SmallText } from 'components/common/text'
import { getDiffFromPast } from 'utils/formatters'
import { useIsDesktop } from 'utils/hooks'
import { LocationMemberInfo } from 'components/positions/location-member-info'
import { Hashtag } from 'components/common/hashtag'

export const StartupSimpleInfo: React.FC<{
  startup: {
    thumbnail: string | null
    name: string
    createdAt: string
    memberCount: number
    location: string
    tags: string[]
    serviceAreas: string[]
    briefIntro: string
    devCount?: number
    pt?: string | null
    fundingRound?: string | null
  }
}> = ({ startup }) => {
  const isDesktop = useIsDesktop()
  return (
    <>
      <StartupSimpleHeader>
        <Logo
          src={startup.thumbnail}
          placeholder=''
          size={isDesktop ? 70 : 54}
        />
        <Column style={{ flex: 1, gap: 6 }}>
          <WithPtBadgeContainer>
            <ChipWrapper>
              <BoldH5Text className='clickable'>{startup.name}</BoldH5Text>
              {getDiffFromPast(startup.createdAt) <= 14 && (
                <Tag variant={TagType.BLUE} size={TagSize.EXTRA_SMALL}>
                  신규 등록
                </Tag>
              )}
            </ChipWrapper>
            {!isDesktop && startup.pt && <PresentationBadge />}
          </WithPtBadgeContainer>
          <LocationMemberInfo
            memberCount={startup.memberCount}
            devCount={startup.devCount}
            location={startup.location}
            fundingRound={startup.fundingRound}
            serviceAreas={startup.serviceAreas}
          />
        </Column>
      </StartupSimpleHeader>
      <Column style={{ gap: 16 }}>
        {startup.tags.length > 0 && (
          <div style={{ maxHeight: 58, overflow: 'hidden' }}>
            <Hashtag data={startup.tags} />
          </div>
        )}
        <SubDescText>{startup.briefIntro}</SubDescText>
      </Column>
    </>
  )
}

const PresentationBadge = () => (
  <Row>
    <PtIcon>
      <Image
        src='/player-play.svg'
        width={10}
        height={10}
        alt='play icon'
        priority
      />
    </PtIcon>
    <BlueText>채용설명회</BlueText>
  </Row>
)

const BoldH5Text = styled(BoldText)`
  font-size: ${(p) => p.theme.fontSize.h5};
`

const SubDescText = styled(DescText)`
  color: ${(p) => p.theme.color.black2};
  line-height: 1.4;
`

const StartupSimpleHeader = styled(Row)`
  gap: 15px;
`

const WithPtBadgeContainer = styled(Row)`
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 5px 15px;
`

const PtIcon = styled(Row)`
  justify-content: center;
  margin-right: 5px;
  width: 16px;
  height: 16px;
  border: 1px solid ${(p) => p.theme.color.secondary};
  border-radius: 50%;
  background-color: ${(p) => p.theme.color.white2};
`

const BlueText = styled(SmallText)`
  color: ${(p) => p.theme.color.secondary};
`
